import React from "react";
import PropTypes from "prop-types";
import { FaListAlt } from "@react-icons/all-files/fa/FaListAlt";
import { FaGripHorizontal } from "@react-icons/all-files/fa/FaGripHorizontal";
import styles from "./button.module.scss";

const getDMSLink = (module) => {
  
  let hercLink = `${process.env.HERCULES_BACKEND_URL}`;
  let linkText = ``;

  switch (module.name) {
    case "top_list":
      hercLink += `toplists/${module.items ? module.items[0].id : ""}/items`;
      linkText = "Edit Toplist";
      break;
    case "bonus":
      hercLink +=  `operators/${module.value?.operator_id}/sites-data/edit/${module.value?.id}`;
      linkText = "Edit Operator";
      break;
    default:
      return null;
  }

  return (
    <a
      className={styles.editModule}
      target="_blank"
      href={hercLink}
      rel="noreferrer"
    >
      <FaListAlt /> {linkText}
    </a>
  );
};

const AdminButtons = ({ page, module, modulePosition }) => (
  <ul className={styles.linkList}>
    <li>{getDMSLink(module)}</li>
    <li>
      <a
        className={styles.editModule}
        target="_blank"
        href={`${process.env.HERCULES_BACKEND_URL}site-pages/${page.id}?index=${modulePosition}#sections`}
        rel="noreferrer"
      >
        <FaGripHorizontal /> Edit Module
      </a>
    </li>
  </ul>
);

AdminButtons.propTypes = {
  page: PropTypes.shape({
    id: PropTypes.number,
  }),
  module: PropTypes.shape({
    modules: PropTypes.shape({}),
  }),
  modulePosition: PropTypes.string,
};

export default AdminButtons;
